import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';


import Table from '@mui/material/Table'; 
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';


import Utilisateur from 'components/Shared/Utilisateur';
import UtilisateurSearch from 'components/Shared/UtilisateurSearch';

import ATCSelect from './ATCSelect';

const styles = theme => ({

    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },

    link: theme.style.link,

    
    button: {
        margin: '8px 8px 0px 0px'
    },


    chip: {
        margin: theme.spacing(0, 0, 0, 0)
    },

    plusButton: {
        maxHeight: '32px'
    },

    container: {
        maxHeight: 350,
    },

    selectedRow: {
        backgroundColor: theme.palette.selected,
        height: '45px'
    },

    row: {
        height: '45px'
    },
});



class AdministrationInterlocuteursSAV extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selection: null
        };
    }


    handleChangeUtilisateur = (type, code, codeATC, id, codePO, nom, prenom) => {
        let { onChangeUtilisateur } = this.props;

        if (id !== 0) {

            onChangeUtilisateur(type, code, codeATC, id, codePO, nom, prenom);

        }
        this.setState(
            {
                ...this.state,
                selection: null
            });
    };



    handleChangeATC = (type, code, codeATC, newCodeATC) => {
        let { onChangeATC } = this.props;

        if (codeATC === '_NEW') {

            if (newCodeATC && newCodeATC !== '_NEW') {

                onChangeATC(type, code, codeATC, newCodeATC);

                this.setState(
                    {
                        ...this.state,
                        selection: { type, code, codeATC: newCodeATC, atcOuInterlocuteur: "INTERLOCUTEUR" }
                    });
            }

        }
    };

    handleCancelChangeATC = () => {
        let { onCancelChangeATC } = this.props;

        onCancelChangeATC();

        this.setState(
            {
                ...this.state,
                selection: null
            });
    };

    handleDeleteInterlocuteurSAV = (interlocuteurSAV) => {
        let { onDeleteInterlocuteurSAV } = this.props;

        onDeleteInterlocuteurSAV(interlocuteurSAV);

        this.setState(
            {
                ...this.state,
                selection: null
            });
    };


    handleDeleteInterlocuteurSAVDepartementATC = (interlocuteurSAV) => {
        let { onDeleteInterlocuteurSAVDepartementATC } = this.props;

        onDeleteInterlocuteurSAVDepartementATC(interlocuteurSAV);

        this.setState(
            {
                ...this.state,
                selection: { type: interlocuteurSAV.type, code: interlocuteurSAV.code, codeATC: interlocuteurSAV.codeATC, atcOuInterlocuteur: "INTERLOCUTEUR" }
            });
    };

    handleClick = (type, code, codeATC, atcOuInterlocuteur) => {

        console.log("handleClick ", type, code, codeATC, atcOuInterlocuteur);

        this.setState(
            {
                ...this.state,
                selection: { type, code, codeATC, atcOuInterlocuteur }
            });

    };


    handleClickAdd = (event, code) => {

        // On stoppe la propagation pour ne pas appeler le handleClick sur la ligne.
        event.stopPropagation();

        console.log("ajout ATC sur département ", code);

        this.props.onAddATC(code);

        this.setState(
            {
                ...this.state,
                selection: { type: 1, code, codeATC: "_NEW", atcOuInterlocuteur: "ATC" }
            });
    };


    handleMouseEnter = (type, code, codeATC) => {
        this.setState(
            {
                ...this.state,
                hover: { type, code, codeATC }
            });
    }
    handleMouseLeave = (type, code, codeATC) => {
        this.setState(
            {
                ...this.state,
                hover: null
            });
    }

    render() {
        let { classes, interlocuteursSAV, departements, magasins, utilisateurs } = this.props;
        let { selection, hover } = this.state;


        if (!departements || !magasins) { return null; }


        return (
            <React.Fragment>

                <Typography gutterBottom variant="h5">
                    Administration des interlocuteurs S.A.V.
                </Typography>




                <Card className={classes.paper}>

                    <Typography gutterBottom variant="h6">
                        par magasin
                    </Typography>

                    <CardContent>


                        <TableContainer className={classes.container}>
                            <Table className={classes.table} stickyHeader size={'small'}>

                                <TableHead>
                                    <TableRow>
                                        <TableCell>Code</TableCell>
                                        <TableCell>Nom</TableCell>
                                        <TableCell>Interlocuteur</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {magasins.map(magasin => {

                                            let interlocuteurSAV = interlocuteursSAV.find(i => i.type === 0 && i.code === magasin.code);

                                            let utilisateur = null;
                                            let utilisateurErreur = null;

                                            if (interlocuteurSAV && interlocuteurSAV.codePOInterlocuteurSAV) {
                                                utilisateur = utilisateurs.find(x => x.codePO === interlocuteurSAV.codePOInterlocuteurSAV);
                                                if (!utilisateur) {
                                                    utilisateurErreur = { codePO: interlocuteurSAV.codePOInterlocuteurSAV };
                                                }
                                            }



                                            let selected = false;
                                            if (selection) {
                                                selected = selection.type === 0 && selection.code === magasin.code
                                            }


                                            return (
                                                <TableRow
                                                    hover
                                                    key={magasin.code}
                                                    onClick={!selected && !utilisateur ? e => this.handleClick(0, magasin.code) : null}
                                                    className={selected ? classes.selectedRow : ''}
                                                >
                                                    <TableCell component="th">{magasin.code}</TableCell>
                                                    <TableCell align="left">{magasin.nom}</TableCell>
                                                    <TableCell align="left">
                                                        {utilisateur && <Utilisateur className={classes.chip} utilisateur={utilisateur} format="deletablechip" onDelete={e => this.handleDeleteInterlocuteurSAV(interlocuteurSAV)}/>}

                                                        {utilisateurErreur && <Utilisateur className={classes.chip} utilisateur={utilisateurErreur} erreur={"Utilisateur manquant ou inactif"} color="secondary" format="deletablechip" onDelete={e => this.handleDeleteInterlocuteurSAV(interlocuteurSAV)} />}

                                                        {!utilisateur && selected && <UtilisateurSearch namespace={"administrationInterlocuteursSAV"} autoFocus onChange={(id, codePO, nom, prenom) => this.handleChangeUtilisateur(0, magasin.code, '', id, codePO, nom, prenom)} />}
                                                        
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </CardContent>


                </Card>

                <Card className={classes.paper}>
                    <Typography gutterBottom variant="h6">
                        par département
                    </Typography>



                    <CardContent>


                        <TableContainer className={classes.container}>
                            <Table className={classes.table} stickyHeader size={'small'}>

                                <TableHead>
                                    <TableRow>
                                        <TableCell>Code</TableCell>
                                        <TableCell>Nom</TableCell>
                                        <TableCell>ATC</TableCell>
                                        <TableCell>Interlocuteur</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {departements.map((departement, index) => {

                                        let interlocuteurSAV = interlocuteursSAV.find(i => i.type === 1 && i.code === departement.code && i.codeATC === '');

                                        let utilisateur = null;
                                        let utilisateurErreur = null;
                                        if (interlocuteurSAV && interlocuteurSAV.codePOInterlocuteurSAV) {
                                            utilisateur = utilisateurs.find(x => x.codePO === interlocuteurSAV.codePOInterlocuteurSAV);
                                            if (!utilisateur) {
                                                utilisateurErreur = { codePO: interlocuteurSAV.codePOInterlocuteurSAV};
                                            }
                                        }

                                        let selected = false;
                                        if (selection) {
                                            selected = selection.type === 1 && selection.code === departement.code && selection.codeATC === '';
                                        }


                                        let hovered = false;
                                        if (hover) {
                                            hovered = hover.type === 1 && hover.code === departement.code && hover.codeATC === '';
                                        }


                                        let rows = [];
                                        rows.push((
                                            <TableRow
                                                hover
                                                key={departement.code}
                                                onClick={!selected && !utilisateur ? e => this.handleClick(1, departement.code, '') : null}
                                                className={selected ? classes.selectedRow : classes.row}

                                                onMouseEnter={e => this.handleMouseEnter(1, departement.code, '')}
                                                onMouseLeave={e => this.handleMouseLeave(1, departement.code, '')}
                                            >
                                                <TableCell component="th">{departement.code}</TableCell>
                                                <TableCell align="left">{departement.nom}</TableCell>
                                                <TableCell align="left">{hovered && !selected && <Button onClick={e => this.handleClickAdd(e, departement.code)} className={classes.plusButton} >+</Button>}</TableCell>
                                                <TableCell align="left">
                                                    {utilisateur && <Utilisateur className={classes.chip} utilisateur={utilisateur} format="deletablechip" onDelete={e => this.handleDeleteInterlocuteurSAV(interlocuteurSAV)} />}

                                                    {utilisateurErreur && <Utilisateur className={classes.chip} utilisateur={utilisateurErreur} erreur={"Utilisateur manquant ou inactif"} color="secondary" format="deletablechip" onDelete={e => this.handleDeleteInterlocuteurSAV(interlocuteurSAV)} />}

                                                    {!utilisateur && selected && <UtilisateurSearch namespace={"administrationInterlocuteursSAV"} autoFocus onChange={(id, codePO, nom, prenom) => this.handleChangeUtilisateur(1, departement.code, '', id, codePO, nom, prenom)} />}

                                                </TableCell>
                                            </TableRow>
                                        ));

                                        let interlocuteursSAVDepartement = interlocuteursSAV.filter(i => i.type === 1 && i.code === departement.code && i.codeATC !== '');


                                        rows = rows.concat(interlocuteursSAVDepartement.map(interlocuteurSAVDepartement => {

                                            let utilisateur = utilisateurs.find(x => x.codePO === interlocuteurSAVDepartement.codePOInterlocuteurSAV);

                                            let selected = false;
                                            if (selection) {
                                                selected = selection.type === 1 && selection.code === departement.code && selection.codeATC === interlocuteurSAVDepartement.codeATC;
                                            }

                                            return (
                                                <TableRow
                                                    hover
                                                    key={departement.code + interlocuteurSAVDepartement.codeATC + interlocuteurSAVDepartement.codePOInterlocuteurSAV}
                                                    onClick={!selected && !utilisateur ? e => this.handleClick(1, departement.code, interlocuteurSAVDepartement.codeATC, interlocuteurSAVDepartement.codeATC === "_NEW" ? "ATC" : "INTERLOCUTEUR") : null}
                                                    className={selected ? classes.selectedRow : ''}
                                                >
                                                    <TableCell component="th">{departement.code}</TableCell>
                                                    <TableCell align="left">{departement.nom}</TableCell>
                                                    <TableCell align="left">
                                                        {interlocuteurSAVDepartement.codeATC && !(selected && selection.atcOuInterlocuteur === "ATC") && <Utilisateur className={classes.chip} utilisateur={{ codePO: interlocuteurSAVDepartement.codeATC }} format="deletablechip" onDelete={e => this.handleDeleteInterlocuteurSAV(interlocuteurSAVDepartement)} />}

                                                        {interlocuteurSAVDepartement.codeATC && selected && selection.atcOuInterlocuteur === "ATC" && <ATCSelect onValid={codeATC => this.handleChangeATC(1, departement.code, interlocuteurSAVDepartement.codeATC, codeATC)} onCancel={this.handleCancelChangeATC}/>}

                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {utilisateur && <Utilisateur className={classes.chip} utilisateur={utilisateur} format="deletablechip" onDelete={e => this.handleDeleteInterlocuteurSAVDepartementATC(interlocuteurSAVDepartement)} />}

                                                        {!utilisateur && selected && selection.atcOuInterlocuteur === "INTERLOCUTEUR" && <UtilisateurSearch namespace={"administrationInterlocuteursSAV"} onChange={(id, codePO, nom, prenom) => this.handleChangeUtilisateur(1, departement.code, interlocuteurSAVDepartement.codeATC, id, codePO, nom, prenom)} />}

                                                    </TableCell>
                                                </TableRow>
                                            );


                                        }));

                                        return rows;
                                    })}
                                </TableBody>

                            </Table>
                        </TableContainer>


                    </CardContent>

                </Card>

            </React.Fragment>


        );
    }
}



AdministrationInterlocuteursSAV.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(AdministrationInterlocuteursSAV);